import { get } from '../Services/http';
import { catchError } from './Error.action';
import {
    STOCK_BALANCE_ASIDE_RECEIVE,
    STOCK_BALANCE_ASIDE_ERROR,
} from '../constants';

export const getStoreStockBalance = (variantSystemId) => (dispatch, getState) => {
    // abort any existing, pending request.
    // It's ok to call .abort() after the fetch has already completed, fetch simply ignores it.
    return get(`/api/stores/inventory/${variantSystemId}`)
        .then((response) => response.json())
        .then((result) => dispatch(receive(result)))
        .catch((ex) => dispatch(catchError(ex, (error) => stockBalanceError(error))));
};

export const stockBalanceError = (error) => ({
    type: STOCK_BALANCE_ASIDE_ERROR,
    payload: {
        error
    },
});

export const receive = (result) => ({
    type: STOCK_BALANCE_ASIDE_RECEIVE,
    payload: {
        result
    },
});

